module.exports = __webpack_public_path__ + "static/media/without.1b0d0fd8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sprayhoodColors/without.jpg
// module id = 30
// module chunks = 0